import { useTheme } from '@hooks/contexts/ThemeContext/ThemeContext'
import React from 'react'

function PaymentConditionTab() {
  const { isNightOrDarkTheme } = useTheme()
  return (
    <div className=' border-t border-gray-3 dark:border-purple desktop-tablet:px-[120px] desktop-tablet:py-[30px] desktop-tablet:border desktop-tablet:rounded-lg desktop-tablet:shadow'>
      <div className='text-[24px]  text-center font-medium font-mitr dark:text-dark-10'>
        ข้อตกลงเงื่อนไขส่วนแบ่งรายได้
      </div>
      <div className='flex justify-between mobile:flex-col mobile:space-y-[40px] desktop-tablet:space-x-[160px] mt-[40px] text-sm dark:text-dark-10 font-light'>
        <div>
          <div className='text-center'>
            ผู้รับบริการตกลงยอมรับส่วนแบ่งรายได้จากการขายรายตอน และอีบุ๊ก
            ซึ่งมีรายละเอียดดังต่อไปนี้
          </div>
          <img
            src={
              isNightOrDarkTheme
                ? '/images/chapterPayment_dark.svg'
                : '/images/chapterPayment.svg'
            }
            alt='Chapter Payment'
            className='mt-[20px]'
          />
        </div>
        <div>
          <div className='text-center'>
            ผู้รับบริการตกลงยอมรับส่วนแบ่งรายได้จากการสนับสนุน
            ซึ่งมีรายละเอียดดังต่อไปนี้
          </div>
          <img
            src={
              isNightOrDarkTheme
                ? '/images/chaSupportPayment_dark.svg'
                : '/images/chaSupportPayment.svg'
            }
            alt='characterSupportPayment'
            className='mt-[20px]'
          />
        </div>
      </div>
      <div className='dark:text-dark-10 mt-[40px] text-[24px] text-center font-medium font-mitr'>
        เงื่อนไขการชำระเงิน
      </div>
      <div className='text-sm  text-[#0c1135] dark:text-dark-10 font-light mt-[20px]'>
        - ยอดขายที่ผ่านช่องทางการชำระเงินต่าง ๆ จะแสดงในรายงานการขายในวันที่ 5
        ของเดือน โดยยอดขายนั้นจะเป็นยอดขายของเดือนที่ผ่านมา เช่น วันที่ 5
        กุมภาพันธ์ จะแสดงผลยอดขายของเดือนมกราคม <div className='mt-[40px]' />-
        การดำเนินการโอนเงินส่วนแบ่งที่ได้หลังจากการหักค่าบริการของ MaReads แล้ว
        จะดำเนินการโอนภายในไม่เกินวันที่ 15 ของเดือน
        โดยยอดการโอนจะยอดของเดือนที่ผ่านมารวมกับยอดเงินค้างชำระสะสม (ถ้ามี) เช่น
        วันที่ 15 กุมภาพันธ์ จะเป็นยอดขายของเดือนมกราคม
        โดยจะโอนเข้าบัญชีธนาคารของท่านที่ได้ลงทะเบียนไว้ในระบบเท่านั้น
        สามารถดูยอดโอนได้ที่รายงานการจ่ายเงิน <div className='mt-[40px]' />-
        การดำเนินการโอนเงินในแต่ละเดือน จะดำเนินการต่อเมื่อยอดขายค้างชำระเกิน
        300 บาท ขึ้นไป (ยอดหักค่าธรรมเนียมต่าง ๆ แล้ว)
        หากมียอดไม่ถึงจะเป็นยอดค้างชำระสะสม เมื่อมียอดเกิน 300 บาท
        จึงจะดำเนินการโอนเงิน <div className='mt-[40px]' />-
        ในกรณีที่บัญชีธนาคารของท่านไม่ใช่บัญชีธนาคารกสิกรไทย
        ทางเราขอสงวนสิทธิ์คิดค่าธรรมเนียมการโอนเงิน 8 บาทต่อครั้ง
        (เฉพาะกรณีที่ยอดโอนต่อครั้งที่ไม่เกิน 2 ล้านบาท)
        <div className='mt-[40px]' />- หากมีการแก้ไขข้อมูลบัญชีธนาคาร
        ข้อมูลดังกล่าวจะถูกนำมาใช้ในการโอนเงินของรอบเดือนถัดไป เช่น
        แก้ไขข้อมูลวันที่ 15 มกราคม
        ข้อมูลนี้จะถูกนำมาใช้ในรอบโอนเงินเดือนกุมภาพันธ์
      </div>
    </div>
  )
}

export default React.memo(PaymentConditionTab)
